import { gql } from '@apollo/client';

export const GET_PERSONAL_VERIFICATION = gql`
    query AllPersonalVerification(
        $id: String
        $receivedStartDate: String
        $receivedEndDate: String
        $verificationStartDate: String
        $verificationEndDate: String
        $personalVerificationMethod: String
        $personalVerificationDocument: String
        $status: String
    ) {
        allPersonalVerification(
            id: $id,
            receivedStartDate: $receivedStartDate,
            receivedEndDate: $receivedEndDate,
            verificationStartDate: $verificationStartDate,
            verificationEndDate: $verificationEndDate,
            personalVerificationMethod: $personalVerificationMethod,
            personalVerificationDocument: $personalVerificationDocument,
            status: $status,
        ) {
            id
            verificationId
            publicId
            personalVerificationDocument
            personalVerificationMethod
            receivedDate
            updateDate
            verificationDate
            state
            result
            reasonCode
            verificationMemo
            isDeleted
            lastDownloadedDate
            isDeletedFromTrustdock
            deleteFromTrustdockDate
        }
    }`;

export const EXPORT_PERSONAL_VERIFICATION_CSV = gql`
    query ExportPersonalVerificationCsv($startDate: String, $endDate: String, $downloadType: String!) {
        exportPersonalVerificationCsv(startDate: $startDate, endDate: $endDate, downloadType: $downloadType)
    }`;

export const GET_PERSONAL_VERIFICATION_DOWNLOADED = gql`
    query Downloaded {
        Downloaded {
            toBeDownloadedCount
            canBeDownloadedCount
            reDownloadCount
            lastDownloadedCustomerUserName
        }
    }`;

export const HAS_NOT_DOWNLOADED_DATA = gql`
    query HasNotDownloadedData {
        hasNotDownloadedData
    }`;
